export default "<app-header></app-header>\n\n<main cdk-scrollable style=\"height: 100%; overflow: auto;\">\n    <router-outlet></router-outlet>\n  \n</main>";